import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CPTCodePerformance from "./CPTCodePerformance/CPTCodePerformance";
import PatientCPTRequirementsMet from "./PatientCPTRequirements/PatientCPTRequirementsMet";
import NonAdherentBackToBackMonths from "./NonAdherentReport/NonAdherentBackToBackMonths";
import MonthlyPhoneConsultationDashboard from "./MonthlyPhoneConsultationDashboard";
import { scrollCptDashboardToTop } from "./common/cptDashboardScroll";
import "./CPTCodePerformance/css/CPTCodesDashboard.css";
import "./PatientCPTRequirements/ReportComponents.css";

const CPT_DASHBOARD_TABS = [
  {
    id: "1",
    icon: "mdi-chart-bar",
    title: "CPT Performance",
    subtitle: "Monitor compliance and billing performance"
  },
  {
    id: "2",
    icon: "mdi-clipboard-text-outline",
    title: "CPT Requirements Report",
    subtitle: "Track patient CPT completion status"
  },
  {
    id: "3",
    icon: "mdi-account-alert-outline",
    title: "Adherence Report",
    subtitle: "Review adherent and non-adherent patients"
  },
  {
    id: "4",
    icon: "mdi-phone-in-talk",
    title: "Monthly Phone Consultations",
    subtitle: "Patient outreach status and team member performance reports."
  }
];

const CPTCodesDashboard = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      requestAnimationFrame(() => {
        scrollCptDashboardToTop(".cpt-dashboard-nav-panel");
      });
    }
  };

  const activeReport = CPT_DASHBOARD_TABS.find((tab) => tab.id === activeTab) || CPT_DASHBOARD_TABS[0];

  return (
    <div className="cpt-dashboard-wrapper">
      <div className="cpt-dashboard-shell">
        <header className="cpt-dashboard-page-header">
          <div className="cpt-dashboard-page-header-main">
            <div className="cpt-dashboard-page-copy">
              <h1 className="cpt-dashboard-page-title">Dashboard Reports</h1>
              <p className="cpt-dashboard-page-subtitle">
                CPT performance, requirements met, adherence, and monthly phone consultation for your panel.
              </p>
            </div>
          </div>
        </header>

        <div className="cpt-dashboard-nav-panel">
          <Nav tabs className="cpt-dashboard-nav" role="tablist" aria-label="CPT dashboard reports">
            {CPT_DASHBOARD_TABS.map((tab) => (
              <NavItem
                key={tab.id}
                className={`cpt-dashboard-tab-item ${activeTab === tab.id ? "active" : ""}`}
              >
                <NavLink onClick={() => toggleTab(tab.id)} role="tab" aria-selected={activeTab === tab.id}>
                  <div className="cpt-dashboard-tab-icon" aria-hidden="true">
                    <i className={`mdi ${tab.icon}`} />
                  </div>
                  <span className="cpt-dashboard-tab-copy">
                    <span className="cpt-dashboard-tab-title">{tab.title}</span>
                    <span className="cpt-dashboard-tab-subtitle">{tab.subtitle}</span>
                  </span>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>

        <div
          className="cpt-dashboard-active-context"
          role="status"
          aria-live="polite"
          aria-label={`Viewing ${activeReport.title}`}
        >
          {/* <p className="cpt-dashboard-active-context-line">
            <span className="cpt-dashboard-active-context-label">Viewing report</span>
            <strong className="cpt-dashboard-active-context-title">{activeReport.title}</strong>
            <span className="cpt-dashboard-active-context-sep" aria-hidden="true">
              –
            </span>
            <span className="cpt-dashboard-active-context-subtitle">{activeReport.subtitle}</span>
          </p> */}
        </div>

        <TabContent activeTab={activeTab} className="cpt-tabs-content cpt-dashboard-tabs-content">
          <TabPane tabId="1">
            {activeTab === "1" && <CPTCodePerformance isActiveTab />}
          </TabPane>
          <TabPane tabId="2">
            {activeTab === "2" && <PatientCPTRequirementsMet isActiveTab />}
          </TabPane>
          <TabPane tabId="3">
            {activeTab === "3" && <NonAdherentBackToBackMonths isActiveTab />}
          </TabPane>
          <TabPane tabId="4">
            {activeTab === "4" && <MonthlyPhoneConsultationDashboard isActiveTab />}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default CPTCodesDashboard;
